import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import style from "../../assets/css/components/Form/Form.module.css";
import {
  AddChangePlayerInitialState,
  AddChangePlayerValidationSchema,
} from "../../utils/changeplayer";
import Button from "../Button/Button";
import Input from "../Input/Input";
import InputSelect from "../Input/InputSelect";

import { socket } from "../../config/socket";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const MySwal = withReactContent(Swal);

function FormChange({ idMatch, teams, playersLocal, playersVisit }) {
  const handleSubmit = async (values) => {
    console.log(values);
    const { team, time, playerOut, playerIn } = values;
    let playersTeam = [];

    if (team === "1") {
      playersTeam = playersLocal;
    } else {
      playersTeam = playersVisit;
    }

    const indexOut = playersTeam.findIndex((obj) => obj.value === playerOut);
    const title = playersTeam[indexOut].label;
    const indexIn = playersTeam.findIndex((obj) => obj.value === playerIn);
    const description = playersTeam[indexIn].label;

    socket.emit(
      "addStory",
      { idMatch, team, time, title, description, type: 7 },
      (story) => {
        MySwal.fire("story agregado");
        console.log(story);
      }
    );
  };
  return (
    <Formik
      initialValues={AddChangePlayerInitialState}
      validationSchema={AddChangePlayerValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.twoColumn)}>
            <InputSelect
              name="team"
              title="Equipo"
              error={touched.team && errors.team}
              options={teams}
              onChange={(selectedOption) => {
                handleChange("team")(selectedOption.value);
              }}
            />
            <Input name="time" title="Minuto de juego" type="number" />
            <InputSelect
              name="playerOut"
              title="Jugador que sale"
              error={touched.playerOut && errors.playerOut}
              options={
                values.team === "1"
                  ? playersLocal
                  : values.team === "2"
                  ? playersVisit
                  : []
              }
              onChange={(selectedOption) => {
                handleChange("playerOut")(selectedOption.value);
              }}
            />
            <InputSelect
              name="playerIn"
              title="Jugador que entra"
              error={touched.playerIn && errors.playerIn}
              options={
                values.team === "1"
                  ? playersLocal
                  : values.team === "2"
                  ? playersVisit
                  : []
              }
              onChange={(selectedOption) => {
                handleChange("playerIn")(selectedOption.value);
              }}
            />
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormChange;
